exports.components = {
  "component---src-pages-404-js": () => import("./../../../src/pages/404.js" /* webpackChunkName: "component---src-pages-404-js" */),
  "component---src-pages-discussion-leaderboard-js": () => import("./../../../src/pages/discussion-leaderboard.js" /* webpackChunkName: "component---src-pages-discussion-leaderboard-js" */),
  "component---src-pages-github-logo-js": () => import("./../../../src/pages/githubLogo.js" /* webpackChunkName: "component---src-pages-github-logo-js" */),
  "component---src-pages-index-js": () => import("./../../../src/pages/index.js" /* webpackChunkName: "component---src-pages-index-js" */),
  "component---src-pages-root-js": () => import("./../../../src/pages/root.js" /* webpackChunkName: "component---src-pages-root-js" */)
}

